export default __webpack_public_path__ + "locales/el-GR/InviteDialog.json?hash=59236342523b57b0722e5fb9bb142821";